/// <reference types="@angular/localize" />

import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";

import "reflect-metadata";

import {AppModule} from "./app/app.module";

window.addEventListener('error', (e) => {
  console.error('Global error:', e.message, e.error);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error('Unhandled promise:', e.reason);
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
